/**
 * Portfolio Category Visible Formatter.
 * Toggles the `visible` boolean on a portfolio category.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.portfolioCategoryVisibleFormatter = function(value, row) {
    let domainId = $('#domain_id').val();
    let pageId = $('#page_id').val();
    let pageModuleId = $('#page_module_id').val();
    let url = '/domains/show/pages/show/modules/show/portfolio/categories/toggle/' + domainId + '/' + pageId + '/' + pageModuleId + '/' + row.id;

    return toggleableFormatter(value, row, 'visible', url);
};